module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "certificados"
    }
  }, [(_vm.listing === true) ? _c('div', {
    attrs: {
      "id": "certificados-list"
    }
  }, [_c('div', {
    staticClass: "row-flex",
    attrs: {
      "id": "certificados-actions"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "vp-h2 vp-module-heading"
  }, [_vm._v("\n          Certificados\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn vp-btn vp-new-btn botao-novo",
    attrs: {
      "to": "/novo"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  }), _vm._v(" Novo certificado")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row-flex",
    attrs: {
      "id": "certificados-items"
    }
  }, _vm._l((_vm.certificados), function(certificado) {
    return _c('div', {
      staticClass: "col-12 small-6 mid-4 cert-item"
    }, [_c('div', {
      staticClass: "card-box"
    }, [_c('div', {
      staticClass: "type-label evento",
      class: certificado.tipo
    }, [(certificado.tipo === 'evento') ? _c('i', {
      staticClass: "fa fa-fw fa-certificate",
      attrs: {
        "title": "Certificado do evento"
      }
    }) : (certificado.tipo === 'atividade') ? _c('i', {
      staticClass: "fa fa-fw fa-tasks",
      attrs: {
        "title": "Certificado da atividade"
      }
    }) : (certificado.tipo === 'trabalho') ? _c('i', {
      staticClass: "fa fa-fw fa-file",
      attrs: {
        "title": "Certificado da trabalho"
      }
    }) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(certificado.nome))]), _vm._v(" "), _c('div', {
      staticClass: "card-data row-flex"
    }, [_c('div', {
      staticClass: "col-12 col status",
      class: (certificado.ativo === '1' ? 'ativo' : 'nao-ativo')
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ({
          content: '<strong>Clique para ' + (certificado.ativo === '1' ? 'desativar' : 'ativar') + ' o certificado</strong>'
        }),
        expression: "{content: '<strong>Clique para '+(certificado.ativo==='1' ? 'desativar' : 'ativar')+' o certificado</strong>'}",
        modifiers: {
          "top": true
        }
      }],
      on: {
        "click": function($event) {
          _vm.handleCertificateActivationStatus(certificado)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-circle"
    }), _vm._v(" "), (certificado.ativo === '1') ? _c('span', [_vm._v("Ativo")]) : _vm._e(), _vm._v(" "), (certificado.ativo === '0') ? _c('span', [_vm._v("Desativado")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer row-flex"
    }, [_c('div', {
      staticClass: "col-12 small-6 grow"
    }, [_c('div', {
      staticClass: "row-flex"
    }, [_c('router-link', {
      staticClass: "btn vp-flat-btn vp-edit-btn",
      attrs: {
        "to": '/' + certificado.id
      }
    }, [_vm._v("Editar")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-12 small-6 grow"
    }, [_c('div', {
      staticClass: "row-flex"
    }, [_c('a', {
      staticClass: "btn vp-flat-btn vp-delete-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deleteCertificado(certificado.id)
        }
      }
    }, [_vm._v("Remover")])])])])])])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8685dfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CertificadosMain.vue
// module id = 218
// module chunks = 2